export const CLOSE_MENU = "Close Menu";
export const OPEN_MENU = "Open Menu";
export const DASHBOARD = "Dashboard";
export const DATA_CENTER = "Data Center";
export const SURVEYS = "Surveys";
export const ADMINISTRATORS = "Administrators";
export const SEASONS = "Seasons";
export const RESOURCES = "Resources";
export const SIGN_OUT = "Sign Out";
export const CHANGE_PASS = "Change Password";
export const SCHOOL='School'
export const HELP_CENTER="Help Center"



// WEBPACK FOOTER //
// ./src/pages/director/DirectorSidebar/constants.ts